import backgroundImage from "../assets/images/background.webp";
import BackgroundImage from "../../../components/ui/BackgroundImage";
import { useState } from "react";
import BodyPartPin from "./BodyPartPin";
import legImage from "../assets/images/Untitled-2.png";
import RightPanel from "./RightPanel";
import medicalImage from "../assets/images/medical.png";

interface Props {
  className?: string;
}

export type BodyPartPinType = {
  name: string;
  value: number;
  direction: "from-r-to-l" | "from-l-to-r";
  x: number;
  y: number;
  image?: string;
};

export type MedicalItemType = {
  name: string;
  description: string;
  image: string;
  id: string;
};

const BodyPartsStats = ({ className = "" }: Props) => {
  const [bodyPartsPins, setBodyPartsPins] = useState<BodyPartPinType[]>([
    { name: "Thing Name", value: 80, x: 48, y: 45, direction: "from-r-to-l" },
    { name: "Left Arm", value: 60, x: 40, y: 52, direction: "from-l-to-r" },
    { name: "Right Arm", value: 75, x: 50, y: 52, direction: "from-r-to-l" },
    { name: "Stomach", value: 55, x: 42, y: 62, direction: "from-l-to-r" },
    { name: "Left Leg", value: 90, x: 40, y: 84, direction: "from-l-to-r" },
    { name: "Right Leg", value: 95, x: 50, y: 84, direction: "from-r-to-l" },
  ]);
  const [medicalItems, setMedicalItems] = useState<MedicalItemType[]>([
    {
      id: "1",
      name: "Thing name",
      description: "Small description right here",
      image: medicalImage,
    },
    {
      id: "2",
      name: "Thing name",
      description: "Small description right here",
      image: medicalImage,
    },
    {
      id: "3",
      name: "Thing name",
      description: "Small description right here",
      image: medicalImage,
    },
    {
      id: "4",
      name: "Thing name",
      description: "Small description right here",
      image: medicalImage,
    },
    {
      id: "5",
      name: "Thing name",
      description: "Small description right here",
      image: medicalImage,
    },
    {
      id: "6",
      name: "Thing name",
      description: "Small description right here",
      image: medicalImage,
    },
  ]);

  return (
    <BackgroundImage
      imageSrc={backgroundImage}
      className={` ${className}`}
      imageClassName="!object-fill"
    >
      <div className="h-screen w-full relative">
        {/* Left side (player with pins) */}
        <div className="relative w-full h-full">
          {/* Body Part Pins */}
          {bodyPartsPins.map((part, index) => (
            <BodyPartPin variant={1} key={index} {...part} />
          ))}
        </div>

        {/* Right Panel (static) */}
        <RightPanel
          className="absolute top-0 bottom-0 right-0"
          medicalItems={medicalItems}
          bodyPartsPins={[
            {
              name: "Cap",
              value: 80,
              y: 5,
              x: 25,
              direction: "from-l-to-r",
              image: legImage,
            },
            {
              name: "Thing Name",
              value: 80,
              y: 25,
              x: 0,
              direction: "from-l-to-r",
              image: legImage,
            },
            {
              name: "Thing Name",
              value: 0,
              y: 27,
              x: 85,
              direction: "from-l-to-r",
              image: legImage,
            },
            {
              name: "Thing Name",
              value: 55,
              y: 50,
              x: 65,
              direction: "from-l-to-r",
              image: legImage,
            },
            {
              name: "Thing Name",
              value: 55,
              y: 85,
              x: 77,
              direction: "from-l-to-r",
              image: legImage,
            },
            {
              name: "Thing Name",
              value: 80,
              y: 95,
              x: 10,
              direction: "from-l-to-r",
              image: legImage,
            },
          ]}
        />
      </div>
    </BackgroundImage>
  );
};

export default BodyPartsStats;
